module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hvrhI"))).then(() => parcelRequire('1iHdE'));